import { render, staticRenderFns } from "./S3UsageReport.vue?vue&type=template&id=96ff0392&"
import script from "./S3UsageReport.vue?vue&type=script&lang=js&"
export * from "./S3UsageReport.vue?vue&type=script&lang=js&"
import style0 from "./S3UsageReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports